(function ($) {

    /*------------------------------------*\
        DEVHUB CREATE MODAL
        Opens/closes creation modals for each CPT.
        Pattern: open btn class  → js-{type}-create-btn
                 modal class     → js-{type}-create-modal
                 close triggers  → js-{type}-modal-close
                 form class      → js-{type}-create-form
        Reloads to edit URL on successful AJAX creation.
    \*------------------------------------*/

    $.fn.devhubCreateModal = function () {

        /* ── Generic open / close ────────────────────────────────── */

        function openModal($modal) {

            $modal.addClass('is-open');
            $('body').css('overflow', 'hidden');

        }

        function closeModal($modal) {

            $modal.removeClass('is-open');
            $('body').css('overflow', '');

        }

        /* ── Design ─────────────────────────────────────────────── */

        $(document).on('click', '.js-design-create-btn', function () {

            openModal($('.js-design-create-modal'));

        });

        $(document).on('click', '.js-design-modal-close', function () {

            closeModal($('.js-design-create-modal'));

        });

        $(document).on('submit', '.js-design-create-form', function (e) {

            e.preventDefault();

            var $form = $(this);
            var $btn  = $form.find('[type="submit"]');

            $btn.prop('disabled', true).text('Creating...');

            $.ajax({
                url:  devhubAjax.ajaxUrl,
                type: 'POST',
                data: {
                    action:  'devhub_create_design',
                    title:   $form.find('[name="title"]').val(),
                    project: $form.find('[name="project"]').val(),
                    nonce:   devhubAjax.designNonce
                },
                success: function (resp) {

                    if (resp.success) {
                        window.location.href = resp.data.edit_url;
                    } else {
                        $btn.prop('disabled', false).text('Create');
                    }

                },
                error: function () {
                    $btn.prop('disabled', false).text('Create');
                }
            });

        });

        /* ── Component ───────────────────────────────────────────── */

        $(document).on('click', '.js-component-create-btn', function () {

            openModal($('.js-component-create-modal'));

        });

        $(document).on('click', '.js-component-modal-close', function () {

            closeModal($('.js-component-create-modal'));

        });

        $(document).on('submit', '.js-component-create-form', function (e) {

            e.preventDefault();

            var $form = $(this);
            var $btn  = $form.find('[type="submit"]');

            $btn.prop('disabled', true).text('Creating...');

            $.ajax({
                url:  devhubAjax.ajaxUrl,
                type: 'POST',
                data: {
                    action:  'devhub_create_component',
                    title:   $form.find('[name="title"]').val(),
                    type:    $form.find('[name="type"]').val(),
                    brand:   $form.find('[name="brand"]').val(),
                    nonce:   devhubAjax.componentNonce
                },
                success: function (resp) {

                    if (resp.success) {
                        window.location.href = resp.data.edit_url;
                    } else {
                        $btn.prop('disabled', false).text('Create');
                    }

                },
                error: function () {
                    $btn.prop('disabled', false).text('Create');
                }
            });

        });

        /* ── Close on Escape ─────────────────────────────────────── */

        $(document).on('keydown', function (e) {

            if ('Escape' === e.key) {

                $('.devhub-modal.is-open').each(function () {

                    closeModal($(this));

                });

            }

        });

        return this;

    };

}(jQuery));
